import { NgClass, NgIf } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FuseConfirmationConfig } from '@fuse/services/confirmation/confirmation.types';

@Component({
    selector     : 'fuse-confirmation-dialog',
    templateUrl  : './dialog.component.html',
    styles       : [
        `
            .fuse-confirmation-dialog-panel {

                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }

                .fuse-confirmation-dialog__cancel {
                    @apply min-w-20 text-secondary #{'!important'};

                    &.mat-mdc-button:not(:disabled) {
                        border: none !important;
                        background: transparent !important;
                    }

                    &.cdk-focused,
                    &.cdk-program-focused,
                    &:focus,
                    &:focus-visible {
                        outline: none !important;
                        box-shadow: none !important;
                    }
                }

                .fuse-confirmation-dialog__confirm {
                    @apply min-w-24 font-semibold shadow-sm #{'!important'};

                    &.mat-mdc-unelevated-button:not(:disabled) {
                        @apply bg-emerald-500 text-white hover:bg-emerald-600 #{'!important'};
                    }

                    &.mat-mdc-unelevated-button.mat-warn:not(:disabled) {
                        @apply bg-warn text-white #{'!important'};
                    }

                    &.mat-mdc-unelevated-button.mat-accent:not(:disabled) {
                        @apply bg-accent text-white #{'!important'};
                    }

                    &.cdk-focused,
                    &.cdk-program-focused,
                    &:focus-visible {
                        outline: 2px solid rgb(16 185 129 / 0.45) !important;
                        outline-offset: 2px !important;
                    }
                }
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [NgIf, MatButtonModule, MatDialogModule, MatIconModule, NgClass],
})
export class FuseConfirmationDialogComponent implements AfterViewInit
{
    /**
     * Constructor
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: FuseConfirmationConfig,
        private elementRef: ElementRef<HTMLElement>,
    )
    {
    }

    ngAfterViewInit(): void
    {
        if (!this.data.actions?.confirm?.show)
        {
            return;
        }

        queueMicrotask(() =>
        {
            this.elementRef.nativeElement
                .querySelector<HTMLButtonElement>('#fuseDialogConfirmButton')
                ?.focus();
        });
    }

}
